import * as orgbookReducer from "../reducers/orgbookReducer";

export const { getBCRegistrationSearchResults, getOrgBookCredential } = orgbookReducer;
